import { useEffect, useState } from 'react';
import { BsRobot } from 'react-icons/bs';
import AjudaTela from '../../components/AjudaTela';
import Layout from '../../components/Layout';
import { api } from '../../services/api';

const AJUDA = {
  titulo: 'Assistente de IA',
  descricao:
    'Controla o widget de chat que aparece em todas as telas do sistema. O assistente ainda está em desenvolvimento — hoje o widget só mostra um aviso de "em breve"; nada do que está aqui envia pergunta pra nenhuma IA de verdade.',
  secoes: [
    {
      titulo: 'Campos',
      campos: [
        { nome: 'Ativar assistente', obrigatorio: false, explicacao: 'Mostra ou esconde a bolha de chat em todas as telas, pra todos os colaboradores dessa fazenda.' },
        { nome: 'Modelo', obrigatorio: false, explicacao: 'Reservado para quando o assistente for implementado — hoje não tem efeito.' },
        { nome: 'Instruções personalizadas', obrigatorio: false, explicacao: 'Reservado para quando o assistente for implementado — hoje não tem efeito.' },
      ],
    },
  ],
  dicas: [
    'A chave de acesso ao provedor de IA nunca fica aqui, nem em nenhuma tela do sistema — por segurança, ela só pode ser configurada como variável de ambiente direto no servidor (Railway), nunca pelo navegador.',
    'Assim que o assistente for implementado de verdade, o modelo e as instruções definidos aqui passam a valer sem precisar editar nenhum código.',
  ],
};

export default function AssistenteIA() {
  const [config, setConfig] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  useEffect(() => {
    carregar();
  }, []);

  const carregar = async () => {
    setCarregando(true);
    setErro('');
    try {
      const res = await api.get('/configuracoes/assistente-ia/');
      setConfig(res.data);
    } catch {
      setErro('Erro ao carregar a configuração do assistente.');
    } finally {
      setCarregando(false);
    }
  };

  const salvar = async (campos) => {
    setSalvando(true);
    setErro(''); setSucesso('');
    try {
      const res = await api.patch('/configuracoes/assistente-ia/', campos);
      setConfig(res.data);
      setSucesso('Configuração salva com sucesso.');
    } catch (err) {
      setErro(err.response?.data?.detail || 'Erro ao salvar a configuração.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Layout>
      <div className="p-6 font-medium max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-2">
          <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
            Assistente de IA <BsRobot size={30} />
          </h2>
          <AjudaTela {...AJUDA} />
        </div>

        <div className="mb-6 p-3 rounded-lg bg-amber-50 border border-amber-200 text-amber-800 text-sm">
          Em desenvolvimento — o widget hoje só mostra "Em breve!" pro colaborador. Nenhuma pergunta é
          enviada pra nenhuma IA ainda.
        </div>

        {erro && <div className="mb-4 p-3 rounded-lg bg-red-100 text-red-700 border border-red-200">{erro}</div>}
        {sucesso && <div className="mb-4 p-3 rounded-lg bg-green-100 text-green-700 border border-green-200">{sucesso}</div>}

        {carregando ? (
          <div className="p-8 text-center text-gray-500">Carregando...</div>
        ) : (
          <div className="bg-white rounded-lg shadow-md border border-gray-200 divide-y divide-gray-200">
            <div className="p-4 flex items-start justify-between gap-4">
              <div>
                <p className="font-semibold text-gray-800">Ativar assistente</p>
                <p className="text-sm text-gray-500 mt-1">
                  Mostra a bolha de chat em todas as telas, pra todos os colaboradores desta fazenda.
                </p>
              </div>
              <button
                type="button"
                onClick={() => salvar({ ativo: !config.ativo })}
                disabled={salvando}
                className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${
                  config.ativo ? 'bg-green-600' : 'bg-gray-300'
                }`}
                title={config.ativo ? 'Ligado' : 'Desligado'}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    config.ativo ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

            <div className="p-4">
              <p className="font-semibold text-gray-800 mb-1">Modelo</p>
              <p className="text-sm text-gray-500 mb-2">Reservado para quando o assistente for implementado — hoje não tem efeito.</p>
              <input
                className="w-full border border-gray-300 rounded-lg p-2 text-sm bg-gray-50"
                value={config.modelo}
                onChange={(e) => setConfig({ ...config, modelo: e.target.value })}
                onBlur={() => salvar({ modelo: config.modelo })}
                disabled={salvando}
              />
            </div>

            <div className="p-4">
              <p className="font-semibold text-gray-800 mb-1">Instruções personalizadas</p>
              <p className="text-sm text-gray-500 mb-2">Reservado para quando o assistente for implementado — hoje não tem efeito.</p>
              <textarea
                className="w-full border border-gray-300 rounded-lg p-2 text-sm bg-gray-50"
                rows={4}
                placeholder='Ex.: "Responda sempre em português, de forma breve e direta."'
                value={config.instrucoes_personalizadas}
                onChange={(e) => setConfig({ ...config, instrucoes_personalizadas: e.target.value })}
                onBlur={() => salvar({ instrucoes_personalizadas: config.instrucoes_personalizadas })}
                disabled={salvando}
              />
            </div>

            <div className="p-4 bg-gray-50">
              <p className="text-sm text-gray-600">
                <strong>Chave de API:</strong> não é configurada aqui. Quando o assistente for
                implementado, quem administra o servidor precisa definir a variável de ambiente
                correspondente direto no Railway — nunca pelo navegador, por segurança.
              </p>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
